import styled from '@emotion/styled';

export const CardContent = styled.div`
  padding: 0;
  margin-top: 0;

  display: block;

  > :last-child {
    padding-bottom: 0;
  }
`;
